// La banda de totales del cobrador (`.kpi-row` del mock), arriba de los filtros: Hoy · Semana ·
// Mes · Meta mes · Ticket prom. Cada una con su conteo de pagos debajo.
import { KpiCell, type KpiItem } from '@/shared/patterns/KpiBar';
import { MONTHLY_GOAL_LABEL, formatPaymentAmount, paymentCountLabel } from '../logic';
import type { PaymentTotals } from '../types';

export function PaymentsTotalsBand({ totals }: { totals: PaymentTotals }) {
    const items: KpiItem[] = [
        {
            label: 'Hoy',
            value: formatPaymentAmount(totals.todayAmount),
            sub: paymentCountLabel(totals.todayCount),
            tone: 'success',
        },
        {
            label: 'Semana',
            value: formatPaymentAmount(totals.weekAmount),
            sub: paymentCountLabel(totals.weekCount),
        },
        {
            label: 'Mes',
            value: formatPaymentAmount(totals.monthAmount),
            sub: paymentCountLabel(totals.monthCount),
        },
        {
            label: 'Meta mes',
            value: `${String(totals.goalPercent)}%`,
            sub: MONTHLY_GOAL_LABEL,
        },
        { label: 'Ticket prom.', value: formatPaymentAmount(totals.averageTicket) },
    ];

    return (
        <div className="flex flex-none items-center overflow-x-auto border-b border-border bg-card px-3 py-2">
            {items.map((item) => (
                <KpiCell key={item.label} item={item} />
            ))}
        </div>
    );
}
